export default "__VITE_ASSET__2d2afb39__"